module.exports = __webpack_public_path__ + "img/logo-window.4b392de3.svg";